import Vue from "vue";
import Vuex from "vuex";

import VersionRepository from "../repositories/versionRepository";

// Modules
import user from "./modules/user";

import users from "./modules/users";
// import auth from "./modules/auth";
import patients from "./modules/patients";
import projects from "./modules/projects";
import colors from "./modules/colors";
import articles from "./modules/articles";
import dropdowns from "./modules/dropdowns";
// import minerva from "./modules/products/minerva";
// import moldedSeat from "./modules/products/moldedSeat";
// import otn from "./modules/products/otn";
// import lift from "./modules/products/lift";
// import retouchingRepair from "./modules/products/retouching_repair";
// import seat from "./modules/products/seat";
// import positioningSeat from "./modules/products/postitioningSeat";
// import upperLimb from "./modules/products/upperLimb";
// import corset from "./modules/products/corset";
// import lowerLimb from "./modules/products/lowerLimb";
import settings from "./modules/settings";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    patients: patients,
    projects: projects,
    users: users,
    colors: colors,
    articles: articles,
    dropdowns: dropdowns,
    settings: settings

    // Products
    // minerva: minerva,
    // moldedSeat: moldedSeat,
    // otn: otn,
    // lift: lift,
    // retouchingRepair: retouchingRepair,
    // seat: seat,
    // positioningSeat: positioningSeat,
    // upperLimb: upperLimb,
    // corset: corset,
    // lowerLimb: lowerLimb
  },
  state: {
    // Api Version
    apiVersion: ""
  },
  mutations: {
    // Set api version
    setApiVersion(state, payload) {
      state.apiVersion = payload;
    }
  },
  actions: {
    // Get api version
    async getApiVersion({ commit }) {
      try {
        const { data } = await VersionRepository.get();
        commit("setApiVersion", data);
      } catch (error) {
        throw error;
      }
    },

    // Gets all we need
    async fetchAll({ dispatch }) {
      await dispatch("users/fetchUsers");
      // await dispatch("agencies/getAgencies");
      // await dispatch("patients/getPatients");
      // await dispatch("projects/getProjects");
      // await dispatch("colors/getColors");
      // await dispatch("articles/getArticles");
      // await dispatch("dropdowns/getDropdowns");
    }

    // Clean all store
    // async cleanAll({ dispatch }) {
    //   await dispatch("agencies/clean");
    //   await dispatch("patients/clean");
    //   await dispatch("articles/cleanArticles");
    // }
  }
});
